
import Form from 'react-bootstrap/Form';
import { useState } from "react";

function InputMobile(props){
  const [placeholder, setPlaceholder] = useState("");
  const [maxLength, setMaxLength] = useState("");
  const [phoneno, setPhoneno] = useState("");

    const geoHandleChange = (e) => {
        let geoItem = FindArrayElementByValue(props.geoList, e.target.value);
        setPlaceholder(geoItem.placeHolder);
        setMaxLength(geoItem.maxLength);
        setPhoneno("");
        //props.setMobile(e);
    }

    const phonenoHandleChange = (e) => {
      setPhoneno(e.target.value);
    }

    return <>
    <Form.Group className="mb-3" >
        {props.geoList.map((geo) => <PrintRadio groupName={props.groupName} key={geo.id} description={geo.display} value={geo.value} passEvent={geoHandleChange} setGeocode={props.setGeocode}></PrintRadio>)}  
        <Form.Control type="text" onChange={ e => { props.setMobile(e); phonenoHandleChange(e); }} value={phoneno} placeholder={placeholder} maxLength={maxLength} />
    </Form.Group>
  </>
}

function PrintRadio(props){
    return <><Form.Check inline="true" type="radio" name={props.groupName} label={props.description} value={props.value} onChange={ e => { props.setGeocode(e); props.passEvent(e)}}/></>
}

function FindArrayElementByValue(array, value) {
    return array.find((element) => {
      return element.value === value;
    })
  }

export default InputMobile;